import api from './api';

const AdminService = {
    /**
     * Obtiene todas las sucursales con sus usuarios asociados
     * Solo para administradores
     * @returns {Promise<Array>} Array de sucursales con usuarios
     */
    getSucursalesConUsuarios: async () => {
        const response = await api.get('/Sucursals/con-usuarios');
        return response.data;
    },

    /**
     * Obtiene las horas aprobadas y rechazadas de un usuario específico
     * Solo para administradores
     * @param {string} usuarioId - ID del usuario
     * @returns {Promise<Object>} Objeto con horas aprobadas, rechazadas y totales
     */
    getHorasAprobadasRechazadas: async (usuarioId) => {
        const response = await api.get(`/Horas/usuario/${usuarioId}/aprobadas-rechazadas`);
        return response.data;
    }
};

export default AdminService;

